import React from 'react';
import PropTypes from 'prop-types';
import CacMapTitleAndDropdown from '../CacMapTitleAndDropdown';
import ClusterDataView from './ClusterDataView';
import ClusterVisualView from "./ClusterVisualView"

const ClusterViewRightContent = props => {
  const { project } = props;
  const {
    thresholds,
    scatOp,
    cellSize,
    bandWidth,
    interval,
    clustersVisible,
  } = props;

  return (
    <div className="view-right-content" data-test="clusterViewRightComponent">
      <CacMapTitleAndDropdown projectTitle={project.title} />
      {project.corrResponse.cm && project.clusterMapView ? (
        <ClusterVisualView
          id="contourZoomChart"
          project={project}
          thresholds={thresholds}
          cellSize={cellSize}
          bandWidth={bandWidth}
          scatOp={scatOp}
          interval={interval}
          clustersVisible={clustersVisible}
        />
      ) : (
        <ClusterDataView project={project} />
      )}
    </div>
  );
};

ClusterViewRightContent.propTypes = {
  project: PropTypes.instanceOf(Object),
  bandWidth: PropTypes.number,
  thresholds: PropTypes.number,
  scatOp: PropTypes.number,
  cellSize: PropTypes.number,
  interval: PropTypes.number,
  clustersVisible: PropTypes.arrayOf(PropTypes.bool),
};

export default ClusterViewRightContent;
